import { c as _c } from "react/compiler-runtime";
import { type MouseEvent, Fragment } from "react";
import { NamePart } from "@/src/components/cards/patient-card/patient-card-header";
import { CopyableContent } from "@/src/components/copyable-content";
import { TooltipProvider } from "@/src/components/shadcn/ui/tooltip";
import { ValerieCardField } from "@/src/components/valerie-card";
import { ComparisonLabel, useComparison } from "@/src/context/comparison-text";
import { properCase } from "@/src/lib/string";
import { Address, AddressParts, getFormattedAddress } from "@/src/models/address";
const ADDRESS_PARTS: {
  key: keyof AddressParts;
  label: string;
  format: (value: string) => string;
}[] = [{
  key: "line1",
  label: "address",
  format: properCase
}, {
  key: "line2",
  label: "address 2",
  format: properCase
}, {
  key: "city",
  label: "city",
  format: properCase
}, {
  key: "state",
  label: "state",
  format: value => value.toUpperCase()
}, {
  key: "postalCode",
  label: "zip code",
  format: value => value
}];
async function copyPart(event: MouseEvent, text: string) {
  event.stopPropagation();
  try {
    await navigator.clipboard.writeText(text);
  } catch {}
}
export function PatientAddressField(t0) {
  const $ = _c(21);
  const {
    address,
    secondaryAddress,
    hasConflict
  } = t0;
  const comparisonLabel = useComparison()?.comparisonLabel ?? ComparisonLabel.EMR;
  let t1;
  if ($[0] !== address) {
    t1 = getFormattedAddress(address);
    $[0] = address;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const fullAddress = t1;
  let T0;
  let t2;
  let t3;
  let t4;
  if ($[2] !== address || $[3] !== fullAddress || $[4] !== hasConflict) {
    let t5;
    if ($[9] !== address) {
      t5 = part => {
        const value = address?.[part.key]?.trim();
        return value ? [{
          ...part,
          value: part.format(value)
        }] : [];
      };
      $[9] = address;
      $[10] = t5;
    } else {
      t5 = $[10];
    }
    const parts = ADDRESS_PARTS.flatMap(t5);
    T0 = ValerieCardField;
    t2 = "Address";
    t3 = 3;
    t4 = fullAddress ? <TooltipProvider><CopyableContent text={fullAddress} textClassName={hasConflict ? "bg-warn/20" : "text-foreground"}>{parts.map((part_0, index) => <Fragment key={part_0.key}>{index > 0 ? parts[index - 1].key === "city" ? ", " : " " : null}<NamePart value={part_0.value} display={part_0.value} label={part_0.label} onCopy={copyPart} /></Fragment>)}</CopyableContent></TooltipProvider> : <span className="text-sm text-muted-foreground/60">—</span>;
    $[2] = address;
    $[3] = fullAddress;
    $[4] = hasConflict;
    $[5] = T0;
    $[6] = t2;
    $[7] = t3;
    $[8] = t4;
  } else {
    T0 = $[5];
    t2 = $[6];
    t3 = $[7];
    t4 = $[8];
  }
  let t5;
  if ($[11] !== comparisonLabel || $[12] !== hasConflict || $[13] !== secondaryAddress) {
    t5 = hasConflict && <div className="mt-1 text-xs text-muted-foreground"><span className="text-warn dark:text-warn">{comparisonLabel}:{" "}<CopyableContent text={getFormattedAddress(secondaryAddress) ?? "N/A"} textClassName="text-warn dark:text-warn" /></span></div>;
    $[11] = comparisonLabel;
    $[12] = hasConflict;
    $[13] = secondaryAddress;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  let t6;
  if ($[15] !== T0 || $[16] !== t2 || $[17] !== t3 || $[18] !== t4 || $[19] !== t5) {
    t6 = <T0 label={t2} colSpan={t3}>{t4}{t5}</T0>;
    $[15] = T0;
    $[16] = t2;
    $[17] = t3;
    $[18] = t4;
    $[19] = t5;
    $[20] = t6;
  } else {
    t6 = $[20];
  }
  return t6;
}